export default __webpack_public_path__ + "static/media/barrier.3fbd1e60.png";